module.exports = __webpack_public_path__ + "static/ranger-03-9756f25f692d686f2e026cdb363e3161.png";